export default __webpack_public_path__ + "static/media/jerry.34c4342b.jpg";